import { render, staticRenderFns } from "./OrdenCompraData.vue?vue&type=template&id=30fce6cc&scoped=true&"
import script from "./OrdenCompraData.vue?vue&type=script&lang=js&"
export * from "./OrdenCompraData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30fce6cc",
  null
  
)

export default component.exports